import { animate, sequence, style, transition, trigger } from '@angular/animations'

export const ActionToggleAnimation = trigger('actionMenu', [
  transition(':enter', [style({ height: 0, overflow: 'hidden' }), sequence([animate('50ms', style({ height: '*' }))])]),
  transition(':leave', [style({ height: '*', overflow: 'hidden' }), sequence([animate('50ms', style({ height: 0 }))])]),
])
